module.exports = __webpack_public_path__ + "img/img_lawyer320.0b21ed77.png";